export default function DeleteAgencyConfirmDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  amSharedModelService,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleConfirmDelete = _handleConfirmDelete;

  /** *********************************************
   * Event Handlers
   */

  function _handleCloseDialog($event) {
    _closeDialog($event);
  }

  function _handleConfirmDelete($event) {
    loaderService.showViewLoader = true;
    return amSharedModelService.deleteAgency(vm.agency, vm.audit.auditId)
      .then(() => {
        alerts.success('The agency has been successfully deleted.');
        $rootScope.$broadcast('refreshAMAgencies');
        $rootScope.$broadcast('deletedAMAgency', { agency: vm.agency });
        $rootScope.$broadcast('refreshAuditAgencies');
        _closeDialog($event);
      }).catch(() => {
        alerts.error('An error occurred while deleting the agency.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  /** *********************************************
   * Private Functions
   */

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.auditTrail.deleteAgencyConfirmDialog);
  }
}

DeleteAgencyConfirmDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'amSharedModelService',
  'loaderService',
  'ssDialogService'
];
